<template>
<div>
  <el-input  type="text" v-model="userEmail" >
  </el-input>
        <el-button @click="logInAsDifferentUser"> Login </el-button>
</div>
</template>

<script>
import EventService from "@/services/EventService.js";

export default {
  
   data(){
       return{
           userEmail: ''
       }
   },
   methods: {
        logInAsDifferentUser(){
            
            EventService.adminGetDifferentUserToken(this.userEmail).then( respone => {
                var differentUserInfoObject = respone.data;
                this.$store.dispatch("adminLoginAsDifferentUser", differentUserInfoObject )
           });
        }
   }

}
</script>

<style>

</style>